export enum LoginType {
  BACKSTAGE = "BACKSTAGE",
  WEAUTH = "WEAUTH",
  ONE_DAY_STAFF = "ONE_DAY_STAFF",
}

export enum LoginState {
  READY,
  WAITING_OTP,
  LOGGED_IN,
}
